<template>
    <hr class="my-2" />
</template>
